"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireWildcard(require("react"));

var _reactFela = require("react-fela");

var _ = require("../..");

var css = _interopRequireWildcard(require("./StickyElement.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The StickyElement component is used to show sticky element that can
 * change content when it becomes sticky
 */
const StickyElement = ({
  content,
  contentHeight,
  stickyContent,
  stickyContentHeight,
  useAnimation = false,
  zIndex = 1,
  onStickyToggled,
  ...otherProps
}) => {
  const [isSticky, setIsSticky] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)(null);
  const {
    renderer
  } = (0, _reactFela.useFela)();
  const animation = renderer.renderKeyframe(css.fadeIn, {});
  (0, _react.useEffect)(() => {
    const container = ref.current;
    const observer = new IntersectionObserver(([{
      rootBounds,
      intersectionRatio,
      boundingClientRect
    }]) => {
      if (rootBounds && boundingClientRect) {
        setIsSticky(intersectionRatio < 1 && rootBounds.top > boundingClientRect.top);
      }
    }, {
      threshold: [1],
      root: container.parentElement
    });
    observer.observe(container);
    return () => {
      observer.unobserve(container);
    };
  }, []);
  (0, _react.useEffect)(() => {
    onStickyToggled === null || onStickyToggled === void 0 ? void 0 : onStickyToggled(isSticky);
  }, [isSticky, onStickyToggled]);
  return (0, _pragma.createFelaElement)(_react.default.Fragment, null, (0, _pragma.createFelaElement)(_.View, _extends({
    css: css.wrapper,
    cssProps: {
      zIndex
    },
    flex: true,
    justifyContent: "center",
    ref: ref
  }, otherProps), isSticky && stickyContent ? (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    css: css.stickyContent,
    cssProps: {
      height: stickyContentHeight,
      animation: useAnimation ? animation : null
    }
  }, stickyContent) : (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    css: css.content,
    cssProps: {
      height: contentHeight
    }
  }, content)), isSticky && stickyContentHeight && (0, _pragma.createFelaElement)(_.View, {
    css: css.compensation,
    cssProps: {
      height: contentHeight - stickyContentHeight
    }
  }));
};

StickyElement.displayName = 'StickyElement';
var _default = StickyElement;
exports.default = _default;
//# sourceMappingURL=StickyElement.js.map